export const firebaseEnvironment = {
  firebase: {
    apiKey: 'AIzaSyDCicYwCrNIUDlZMxu6y3XGiZC_5qe32es',
    authDomain: 'offconon-303617.firebaseapp.com',
    projectId: 'offconon-303617',
    storageBucket: 'offconon-303617.appspot.com',
    messagingSenderId: '235695738921',
    appId: '1:235695738921:web:cd558ca1353db5de0e4c38',
    measurementId: 'G-XP6MBHRQL6',
    vapidKey:
      'BJZ4J0LNh-LERtKEvj63e3rhJ2PM1a-1xgps7sySa6JWHLMokDBv32wVZxm078FHGCtTS-X1cfHlBWlhIbsKp3c',
  },
};
